import { baseUrl, contracts } from "./config";
import { store } from "./store/store";
import { setTokenAllowance, setTokenSold } from "./store/wallet/wallet.slice";
import { toast } from "react-toastify";
import axios from "axios";
// import TronWeb from 'tronweb';
const TronWeb = require("tronweb");
const HttpProvider = TronWeb.providers.HttpProvider;
const fullNode = new HttpProvider("https://api.trongrid.io");
const solidityNode = new HttpProvider("https://api.trongrid.io");
const eventServer = new HttpProvider("https://api.trongrid.io");
// const privateKey = "b3d65773c80c1e09bb39a765981b9f75c34ff87d86461081eb3c21168a9863e2";
// const tronGridApiKey = "7d30f2e0-7e40-4122-a6dc-36bcf8d15419"

export const tronWeb = new TronWeb(fullNode, solidityNode, eventServer);
tronWeb.setAddress("TPFPUNE8GgiPSWGh48o3nKCMk6bawLajPE");
// tronWeb.setHeader({ "TRON-PRO-API-KEY": tronGridApiKey });
// const tronWeb = new TronWeb({
//     fullHost: "https://api.trongrid.io",
//     Headers: {
//         "TRON-PRO-API-KEY": "7d30f2e0-7e40-4122-a6dc-36bcf8d15419"
//     }
// });
// @ts-ignore
// export const tronWeb: any = new TronWeb({
//     fullHost: "https://api.shasta.trongrid.io",
// });
if (typeof window !== "undefined") {
  (window as any).tronWeb1 = tronWeb;
}

export const showNotification = (message: string, type = "success") => {
  if (type === "success") {
    toast.success(message);
  } else {
    toast.error(message);
  }
};

export const formatNumber = (num: number, precision = 2) => {
  const map = [
    { suffix: "T", threshold: 1e12 },
    { suffix: "B", threshold: 1e9 },
    { suffix: "M", threshold: 1e6 },
    { suffix: "K", threshold: 1e3 },
    { suffix: "", threshold: 1 },
  ];

  const found = map.find((x) => Math.abs(num) >= x.threshold);
  if (found) {
    const formatted = (num / found.threshold).toFixed(precision) + found.suffix;
    return formatted;
  }

  return num;
};
